const data = [
    {
        id: 0,
        image: "images/sm1.png",
        alt: "photoshop",
    },
    {
        id: 1,
        image: "images/sm2.png",
        alt: "figma",
    },
    {
        id: 2,
        image: "images/sm3.png",
        alt: "xd",
    },
    {
        id: 3,
        image: "images/sm4.png",
        alt: "html",
    },
    {
        id: 4,
        image: "images/sm5.png",
        alt: "css",
    },
    {
        id: 5,
        image: "images/card1.png",
        alt: "bootstrap",
    },
    {
        id: 6,
        image: "images/card2.png",
        alt: "materialize css",
    },
    {
        id: 7,
        image: "images/card3.png",
        alt: "tailwind css",
    },
    {
        id: 8,
        image: "images/card4.png",
        alt: "js",
    },
    {
        id: 9,
        image: "images/card5.png",
        alt: "jquery",
    },
    {
        id: 28,
        image: "images/card6.png",
        alt: "react js",
    },
    {
        id: 10,
        image: "images/card7.png",
        alt: "material ui",
    },
    {
        id: 11,
        image: "images/card8.png",
        alt: "chart js",
    },
    {
        id: 12,
        image: "images/form1.png",
        alt: "next js",
    },
    {
        id: 13,
        image: "images/form2.png",
        alt: "scss",
    },
    {
        id: 14,
        image: "images/form3.png",
        alt: "postman",
    },
    {
        id: 15,
        image: "images/form4.png",
        alt: "illustrator",
    },
    {
        id: 16,
        image: "images/form5.png",
        alt: "firebase",
    },
    {
        id: 17,
        image: "images/form6.png",
        alt: "github",
    },
    {
        id: 18,
        image: "images/form7.png",
        alt: "github",
    },
    {
        id: 19,
        image: "images/form8.png",
        alt: "github",
    },
    {
        id: 20,
        image: "images/profile1.png",
        alt: "github",
    },
    {
        id: 21,
        image: "images/profile2.png",
        alt: "github",
    },
    {
        id: 22,
        image: "images/profile3.png",
        alt: "github",
    },
    {
        id: 23,
        image: "images/profile4.png",
        alt: "github",
    },
    {
        id: 24,
        image: "images/profile5.png",
        alt: "github",
    },
    {
        id: 25,
        image: "images/profile6.png",
        alt: "github",
    },
    {
        id: 26,
        image: "images/profile7.png",
        alt: "github",
    },
    {
        id: 27,
        image: "images/profile8.png",
        alt: "github",
    },
];

export default data;
